module.exports = __webpack_public_path__ + "static/usabilityTesting1-b1e2b6bf0d56037283ef796ba953fa52.svg";